import React from "react";
import GAAddOrganizationContainer from "../../modules/GAOrganizations/containers/GAAddOrganizationContainer/GAAddOrganizationContainer";

const GAAddOrganization = () => {
  return <GAAddOrganizationContainer />;
};

export default GAAddOrganization;
